import { frontendURL } from 'dashboard/helper/URLHelper';

const CALENDAR_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/calendar'),
    name: 'calendar',
    meta: {
      permissions: CALENDAR_PERMISSIONS,
    },
    component: () => import('./CalendarView.vue'),
  },
];
